<template>
  <div :class="{ 'text-field-money': money, 'mt-4': separateLabel }">
    <label class="subtitle-1 mb-2 d-block" v-if="separateLabel">
      {{ separateLabel }}:
    </label>
    <v-text-field
      :value="value"
      :label="fieldLabel"
      :rules="rules"
      @keyup="$emit('update:value', $event.target.value)"
      validate-on-blur
      :suffix="suffix"
      :prefix="money ? '$' : null"
      :class="{
        'mt-0': separateLabel,
        'pt-0': separateLabel,
      }"
    ></v-text-field>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {};
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    suffix: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    money: {
      type: Boolean,
    },
  },
  computed: {
    fieldLabel() {
      return this.label.length > 55 ? "" : this.label;
    },
    separateLabel() {
      return this.label.length > 55 ? this.label : "";
    },
  },
});
</script>
